export const isAdminApprovalResponse = (response: unknown): boolean =>
  !!response &&
  typeof response === 'object' &&
  'canReview' in response &&
  'expiresAt' in response &&
  'requestedBy' in response;
